import React, { Component } from "react";
import PropTypes from "prop-types";
import { Grid } from "semantic-ui-react";
import styles from "./styles.less";
import ResultBox from "./ResultBox";
import ThumbNailCustom from "../ThumbNailCustom";

export class ResultsGroup extends Component {
  renderRoomBoxMarkUp = result => {
    const {
      titles,
      isIE,
      onShowDetailsClick,
      MoreDetailsTitle,
      onResultClick,
      propertyType,
      isMobileView,
      showPricePerNightThumb,
      checkinDate,
      checkoutDate,
      //clubUserLoggedIn,
      discountClubConfig,
      isPromoCodeValid
    } = this.props;
    return (
      <ThumbNailCustom
        titles={titles}
        isIE={isIE}
        showClubPrices={discountClubConfig && discountClubConfig.Active}
        onClick={onResultClick}
        product={result}
        onShowDetailsClick={onShowDetailsClick}
        MoreDetailsTitle={MoreDetailsTitle}
        propertyType={propertyType}
        isMobileView={isMobileView}
        showPricePerNightThumb={showPricePerNightThumb}
        checkinDate={checkinDate}
        checkoutDate={checkoutDate}
        isPromoCodeValid={isPromoCodeValid}
      />
    );
  };

  renderBox = result => {
    const {
      isRtl,
      titles,
      onResultClick,
      onShowDetailsClick,
      isMobileView,
      normalizeResult,
      isDeals,
      isRegionResult,
      isIos
    } = this.props;
    const normalizedResult = normalizeResult ? normalizeResult(result) : result;
    return (
      <ResultBox
        isMobileView={isMobileView}
        isRegionResult={isRegionResult}
        className={styles.roomReusltBoxWrapper}
        onShowDetailsClick={onShowDetailsClick}
        onClick={onResultClick}
        result={normalizedResult}
        isRtl={isRtl}
        titles={titles}
        isDeals={isDeals}
        renderMarkup={this.renderRoomBoxMarkUp}
        isIos={isIos}
      />
    );
  };

  render() {
    const { results, isRtl } = this.props;

    return (
      <Grid
        //centered
        className={styles.mainResultsWrapper}
        textAlign={isRtl ? "right" : "left"}
      >
        {results.map((result, key) => (
          <Grid.Column
            className={styles.resultBoxRow}
            mobile={16}
            tablet={16}
            computer={5}
            key={key}
          >
            {this.renderBox(result, key)}
          </Grid.Column>
        ))}
      </Grid>
    );
  }
}

ResultsGroup.defaultProps = {
  isRtl: false,
  isMobileView: false,
  isRegionResult: false,
  titles: {},
  results: [],
  onShowDetailsClick: () => {},
  onResultClick: () => {}
};

ResultsGroup.propTypes = {
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool,
  isRegionResult: PropTypes.bool,
  titles: PropTypes.object,
  results: PropTypes.array,
  onResultClick: PropTypes.func,
  onShowDetailsClick: PropTypes.func,
  normalizeResult: PropTypes.func,
  isDeals: PropTypes.bool,
  isIos: PropTypes.bool,
  MoreDetailsTitle: PropTypes.string,
  propertyType: PropTypes.string,
  isIE: PropTypes.bool,
  showPricePerNightThumb: PropTypes.bool,
  checkinDate: PropTypes.string,
  checkoutDate: PropTypes.string
  //clubUserLoggedIn: PropTypes.bool
};

export default ResultsGroup;



// WEBPACK FOOTER //
// ./src/components/ResultsGroup/ResultsGroup.js